export default "__VITE_ASSET__DK3w$kns__"